import { render, staticRenderFns } from "./AlertOccurrenceDetailModal.vue?vue&type=template&id=46e5b1f4"
import script from "./AlertOccurrenceDetailModal.vue?vue&type=script&lang=js"
export * from "./AlertOccurrenceDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports